let g_devtricker_confirm_deletion_showed = [];

document.addEventListener('DOMContentLoaded', function () {
    devtricker_showDeleteButtonToCommentAuthorOnLoad();
});

function devtricker_showDeleteButtonToCommentAuthorOnLoad() {

    document.querySelectorAll('li.comment').forEach(commentLi => {

        const commentAuthorId = commentLi.getAttribute('data-author-id');
        if (commentAuthorId == devtricker_getTheLoggedUserId()) {
            const deleteButton = commentLi.querySelector('.comment-other-options .delete-comment-li');
            if (deleteButton) {
                deleteButton.style.display = 'block';
            }
        }
    });
}

async function devtricker_deleteComment(event, button) {

    event.preventDefault();
    event.stopPropagation();

    let commentId = button.closest('.comment').id.split('-')[2];
    let commentAuthorId = button.closest('.comment').getAttribute('data-author-id');

    try {

        if (commentAuthorId == devtricker_getTheLoggedUserId()) {

            if (g_devtricker_confirm_deletion_showed[commentId]) {
                devtricker_deleting(button);

                await devtricker_ajax_deleteComment(commentId);

                let commentParentId = 0;
                let parent = document.getElementById(`li-comment-${commentId}`).closest('.comment-list > .comment');

                if (parent) {
                    commentParentId = parent.id.split('-')[2];
                }

                setTimeout(devtricker_warmUpCache, 2000);

                devtricker_removeCommentFromDocument(commentId);
                devtricker_incrementMainThreadCommentCounter(-1);
                devtricker_updateCommentsNumberTooltip(-1);
                devtricker_updateCommentsNumberButton2(-1);

                devtricker_incrementRepliesText(commentParentId, -1);

            } else {
                devtricker_showConfirmation(button, commentId);
                g_devtricker_confirm_deletion_showed[commentId] = true;
            }

        } else {
            delete g_devtricker_confirm_deletion_showed[commentId];
            throw new Error('Current user is not the author of the comment.');

        }

    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR, "Error when try delete comment.");
        devtricker_showCommentToast(devtricker_createErrorToast('top'));
    }
}

function devtricker_deleting(button) {

    button.innerHTML = `
            <span class='icon icon-trash'></span><span>${g_devtricker_i18n.deleting}</span>`;
    button.classList.add('confirm-deletion');
}

function devtricker_showConfirmation(button, commentId) {
    let original = button.innerHTML;

    button.innerHTML = `
            <span class='icon icon-trash'></span>
            Click to delete</span>`;
    button.classList.add('confirm-deletion');

    setTimeout(function () {
        delete g_devtricker_confirm_deletion_showed[commentId];
        button.innerHTML = original;
        button.classList.remove('confirm-deletion')
    }, 7000);
}

function devtricker_showSuccessDeleteCommentTost() {
    const toast = devtricker_createSuccessToast('The comment was successfully removed.', 'top');
    devtricker_showCommentToast(toast);
}

function devtricker_removeCommentFromDocument(commentId) {
    const commentElement = document.getElementById('li-comment-' + commentId);
    if (commentElement) {
        commentElement.classList.add('fade-out');

        commentElement.addEventListener('transitionend', function () {
            commentElement.remove();
            devtricker_showSuccessDeleteCommentTost();
        });
    }
}

async function devtricker_ajax_deleteComment(commentId) {

    const formData = new FormData();
    formData.append('action', 'devtricker_delete_comment');
    formData.append('nonce', await devtricker_process_getDevtrickerNonce());
    formData.append('comment_id', commentId);

    fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        credentials: 'same-origin',
        body: formData
    })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                let commentParentId = 0;
                let parent = document.getElementById(`li-comment-${commentId}`).closest('.comment-list > .comment');

                if (parent) {
                    commentParentId = parent.id.split('-')[2];
                }

                setTimeout(devtricker_warmUpCache, 2000);

                devtricker_removeCommentFromDocument(commentId);
                devtricker_incrementMainThreadCommentCounter(-1);
                devtricker_updateCommentsNumberTooltip(-1);
                devtricker_updateCommentsNumberButton2(-1);


                devtricker_incrementRepliesText(commentParentId, -1);

            } else {
                devtricker_showCommentToast(devtricker_createErrorToast('top'));
            }
        })
        .catch((error) => {
            devtricker_log(error, devtricker_log_level.ERROR);
            devtricker_showCommentToast(devtricker_createErrorToast('top'));
        });
}

function devtricker_showCommentDeletedToast() {

    const commentDeletedToast = document.getElementById('comment-deleted-toast');

    if (commentDeletedToast) {
        const toastBootstrap = bootstrap.Toast.getOrCreateInstance(commentDeletedToast);
        toastBootstrap.show();
    }
}